"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCalculator = useCalculator;
const react_1 = require("react");
const stores_1 = require("../stores/index.js");
const calculator_1 = require("../../view-models/calculator.js");
function useCalculator() {
    const calculator = (0, stores_1.useCalculatorStore)((state) => state.data.calculator);
    return (0, react_1.useMemo)(() => (0, calculator_1.calculatorViewModel)(calculator), [calculator]);
}
